import { cx } from '@chakra-ui/utils';

import {
  Box,
  Flex,
  PartThumbnail,
  Text,
  Tooltip,
  useFileContext,
  type TooltipProps,
} from '@frontend/components';
import { formatFileSize } from '@frontend/utils';

export type FileTooltipProps = TooltipProps;

export const FileTooltip = ({
  className,
  children,
  ...restProps
}: FileTooltipProps) => {
  const {
    assemblyParentFilename,
    containsVirus,
    filename,
    fileSize,
    fileType,
    uuid,
    uploaded,
  } = useFileContext();

  return (
    <Tooltip
      className={cx('file-tooltip', className)}
      label={
        <Flex alignItems="stretch" gap={1}>
          <Box
            width={15}
            minHeight={15}
            backgroundImage="linear-gradient(to bottom right, #fff, #ddd)"
            alignSelf="stretch"
            flexShrink={0}
            borderRadius="2px"
            boxShadow="inset 0 0 0 1px #00000005"
          >
            <PartThumbnail
              partFileUuid={uuid}
              containsVirus={containsVirus}
              filename={filename}
              fileType={fileType}
              borderWidth={0}
            />
          </Box>
          <Flex
            flexDirection="column"
            justifyContent="space-between"
            alignItems="stretch"
            gap={1}
          >
            <Flex flexDirection="column">
              <Text
                as="span"
                color="page.surface"
                fontWeight="interactive"
                wordBreak="break-word"
              >
                {filename}
              </Text>
              {assemblyParentFilename && (
                <Text
                  as="span"
                  size="sm"
                  color="feature.placeholder"
                  fontWeight="interactive"
                  wordBreak="break-word"
                >
                  Derived from {assemblyParentFilename}
                </Text>
              )}
            </Flex>
            <Flex flexDirection="column">
              <Text
                as="span"
                size="sm"
                color="feature.placeholder"
                fontWeight="interactive"
              >
                {fileType.toUpperCase()} · {formatFileSize(fileSize)}
              </Text>
              <Text
                as="span"
                size="sm"
                color="feature.placeholder"
                fontWeight="interactive"
              >
                {uploaded}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      }
      padding={0.75}
      variant="expanded"
      {...restProps}
    >
      {children}
    </Tooltip>
  );
};
